import iconError from '@/assets/error.png';
import iconSuccess from '@/assets/success.png';
import Button from '@/Components/atoms/Button';
import Text from '@/Components/atoms/Text';
import TextWithIcon from '@/Components/molecules/TextWithIcon';
import Store from '@/Store';
import { mappingTypeText } from '@/utils';
import { servizioClientiCta } from '@/utils/cta';
import { findImageByName } from '@/utils/findImageByName';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import ConsultantCard from '../ConsultantCard';
import { Props } from './StatusCard.type';

import './StatusCard.scss';

const StatusCard: FC<Props> = props => {
  const { t } = useTranslation();
  const requestData = Store.useRequestStore(store => store.data);
  const templateStore = Store.useTemplateStore(store => store);
  const templateType = templateStore.data.type;
  const iconsStore = Store.useIconsStore(store => store.data.icons);
  const baseKey = mappingTypeText[templateType];
  const hasInfoAgent = !!requestData.agent_name && !!requestData.agent_phone;

  return (
    <div className="status-card">
      <TextWithIcon
        text={{
          type: 'h2',
          children: t(`${baseKey}.THANK_YOU.STATUS.${props.success ? 'SUCCESS' : 'ERROR'}_TITLE`),
        }}
        iconLeft={{ src: props.success ? iconSuccess : iconError }}
      />
      <div className="info-status-message">
        {props.success && (
          <>
            <Text
              className={templateType === 'power' ? 'fw-600' : ''}
              type="span"
              children={t(`${baseKey}.THANK_YOU.STATUS.SUCCESS_SUBTITLE_1`)}
            />
            <Text type="span" children={props.email || 'e-mail'} />
            <Text
              className={templateType === 'power' ? 'fw-600' : ''}
              type="span"
              children={t(`${baseKey}.THANK_YOU.STATUS.SUCCESS_SUBTITLE_2`)}
            />
          </>
        )}
        {!props.success && (
          <Text
            className={templateType === 'power' ? 'fw-600' : ''}
            type="span"
            children={t(`${baseKey}.THANK_YOU.STATUS.ERROR_SUBTITLE`)}
          />
        )}
      </div>
      {templateType === 'power' && hasInfoAgent && (
        <div className="section-consultant" style={{ marginTop: 20 }}>
          <Text
            className={templateType === 'power' ? 'fw-600' : ''}
            type="span"
            children={t(`POWER.THANK_YOU.STATUS.TITLE_CONSULTANT_CARD`)}
          />

          <ConsultantCard
            fullname={requestData.agent_name}
            phone={requestData.agent_phone}
            email={requestData.agent_email}
            icon={findImageByName(iconsStore, requestData.agent_icon || 'consulente_icona.png')}
          />
        </div>
      )}
      {!props.success && templateType === 'sign' && (
        <Button onClick={servizioClientiCta} text={t('THANK_YOU.STATUS.CONTACT_CUSTOMER_SERVICE')} />
      )}
    </div>
  );
};

export { StatusCard };
